import { useSearchParams } from "react-router-dom";

export const usePagination = (defaultLimit?: number) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = Number(searchParams.get("page")) || 1;
  const limit = Number(searchParams.get("limit")) || defaultLimit || 10;

  const updateParams = (newParams: Record<string, string | number>) => {
    const url = new URL(window.location.href);
    const { searchParams } = url;
    Object.entries(newParams).forEach(([key, value]) => {
      searchParams.set(key, String(value));
    });
    setSearchParams(searchParams);
  };

  const setPage = (page: number) => updateParams({ page });
  const setLimit = (limit: number) => updateParams({ limit, page: 1 });

  return { page, limit, setPage, setLimit };
};
